module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Molly Seymour is a young writer who got into writing because he wanted to find a creative way to inspire people, to get people talking about what he feels is an injustice in our society particularly when it comes to disabled people. There is a loss off human potential as disabled people, a part of human evolution, are constantly ignored. Now even though disabilities aren’t seen as the ideal body type but behind their disability, the people are just the same as any one of us. We all have a desire to be loved, we all have a desire to be happy and we all certainly have a desire to be successful, no matter our background. By helping disabled people, Molly is helping humanity move forward to becoming a more accepting society and you can help him by supporting this book. Doing so, you are playing your part in humanity embracing humanity as a whole. Thankyou.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0